import { streamLainAnimationController } from '@blocksuite/affine/shared/utils';
import { type HTMLAttributes, useLayoutEffect, useRef } from 'react';

import * as styles from './styles.css';

/** Keep the opaque header surface in place while the current group label changes. */
export function MasonryStickyHeader({
  groupId,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement> & { groupId: string }) {
  const content = useRef<HTMLDivElement>(null);
  const previous = useRef(groupId);
  useLayoutEffect(() => {
    if (previous.current === groupId) return;
    previous.current = groupId;
    if (!content.current) return;
    const handle = streamLainAnimationController.play(
      content.current,
      [{ opacity: 0 }, { opacity: 1 }],
      'enter'
    );
    return () => handle.cancel();
  }, [groupId]);
  return (
    <div {...props} data-masonry-sticky-group-header={groupId}>
      <div ref={content} className={styles.stickyContent}>
        {children}
      </div>
    </div>
  );
}
